import type { Platform } from './types.ts';

export type { BackupFolder, OpenedFile, Platform, SaveResult } from './types.ts';

export function isTauri(): boolean {
  return typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window;
}

/** Load the right implementation. The Tauri code is only fetched inside the desktop app. */
export async function loadPlatform(): Promise<Platform> {
  if (isTauri()) return (await import('./tauri.ts')).createTauriPlatform();
  return (await import('./web.ts')).createWebPlatform();
}
export * from './recovery.ts';
export * from './library.ts';
